export default __webpack_public_path__ + "static/media/ic_error.5be12d86.svg";